import React from "react";

type PermissionSwitchProps = {
  value: "vue" | "ecriture" | null;
  disabled?: boolean;
  onChange: (value: "vue" | "ecriture") => void;
};

export const PermissionSwitch: React.FC<PermissionSwitchProps> = ({
                                                                    value,
                                                                    disabled = false,
                                                                    onChange,
                                                                  }) => {
  const isView = value === "vue" || value === null; // Vue par défaut

  return (
    <div className="flex items-center">
      <div className="relative inline-flex items-center">
        <span className="mr-3 text-xs font-medium text-gray-700">Vue</span>

        <button
          type="button"
          disabled={disabled}
          onClick={() => !disabled && onChange(isView ? "ecriture" : "vue")}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500
            ${isView ? "bg-gray-200" : "bg-indigo-600 shadow-inner"}
            ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:shadow-md"}
          `}
          aria-label={isView ? "Passer à Écriture" : "Passer à Vue"}
        >
          <span
            className={`
              pointer-events-none absolute mx-0.5 inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200 ease-in-out
              ${isView ? "translate-x-0" : "translate-x-5"}
            `}
          />
        </button>

        <span className="ml-3 text-xs font-medium text-gray-700">Écriture</span>
      </div>
    </div>
  );
};